import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 45px;\n  margin-bottom: ", ";\n  margin-top: ", ";\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import throttle from 'lodash/throttle';
import { InView } from 'react-intersection-observer';
import { Loader } from './Loader';
var Target = styled.div(_templateObject(), function (props) {
  return props.margin && props.contentPositionBottom ? "".concat(props.margin, "px") : '0';
}, function (props) {
  return props.margin && !props.contentPositionBottom ? "".concat(props.margin, "px") : '0';
});
var THROTTLE_TIME = 240;
var DEFAULT_SCROLL_BACK_COMPENSATION = 81;
/**
 * Component for detecting top or bottom of the list and fire the callback.
 * An empty div is for detecting top or bottom of the tracable object.
 *
 * isLoading - should be true if it is loading it now.
 * shouldLoadMore - should be true if there still is something more to load.
 * scrollBackCompensation - how far to comepsate the scroll position to scroll to the same
 * position as it was previously.
 *
 * @example ./__docs__/LazyLoad.md
 */

export var LazyLoad = function LazyLoad(_ref) {
  var children = _ref.children,
      onLoadMore = _ref.onLoadMore,
      _ref$contentPositionB = _ref.contentPositionBottom,
      contentPositionBottom = _ref$contentPositionB === void 0 ? false : _ref$contentPositionB,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$shouldLoadMore = _ref.shouldLoadMore,
      shouldLoadMore = _ref$shouldLoadMore === void 0 ? false : _ref$shouldLoadMore,
      margin = _ref.margin,
      className = _ref.className,
      _ref$scrollBackCompen = _ref.scrollBackCompensation,
      scrollBackCompensation = _ref$scrollBackCompen === void 0 ? DEFAULT_SCROLL_BACK_COMPENSATION : _ref$scrollBackCompen,
      _ref$defaultRoot = _ref.defaultRoot,
      defaultRoot = _ref$defaultRoot === void 0 ? false : _ref$defaultRoot,
      onScroll = _ref.onScroll;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      previousContentHeight = _useState2[0],
      setPreviousContentHeight = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      shouldScrollBackToTop = _useState4[0],
      setShouldScrollBackToTop = _useState4[1];

  var mainContainerRef = useRef(null);
  useEffect(function () {
    var contentHeight = mainContainerRef.current ? mainContainerRef.current.scrollHeight : 0;

    if (!contentPositionBottom && previousContentHeight && previousContentHeight !== contentHeight && shouldScrollBackToTop) {
      var scrollTopPosition = contentHeight - previousContentHeight + scrollBackCompensation;

      if (mainContainerRef.current) {
        mainContainerRef.current.scrollTop = scrollTopPosition;
        setPreviousContentHeight(contentHeight);
        setShouldScrollBackToTop(false);
      }
    }
  }, [contentPositionBottom, previousContentHeight, scrollBackCompensation, children, shouldScrollBackToTop]);

  var handleOnChange = function handleOnChange(inView) {
    if (inView && shouldLoadMore && !isLoading) {
      setPreviousContentHeight(mainContainerRef.current ? mainContainerRef.current.scrollHeight : 0);
      setShouldScrollBackToTop(true);
      onLoadMore();
    }
  };

  var inViewContent = React.createElement(InView, {
    root: defaultRoot ? undefined : mainContainerRef.current,
    onChange: throttle(handleOnChange, THROTTLE_TIME, {
      leading: false,
      trailing: true
    })
  }, function (_ref2) {
    var ref = _ref2.ref;
    return React.createElement("div", {
      ref: ref
    }, shouldLoadMore && React.createElement(Target, {
      margin: margin,
      contentPositionBottom: contentPositionBottom
    }, isLoading && React.createElement(Loader, {
      size: 25
    })));
  });
  return React.createElement("div", {
    ref: mainContainerRef,
    className: className,
    onScroll: onScroll
  }, !contentPositionBottom && inViewContent, children, contentPositionBottom && inViewContent);
};